export * from './localized-date.pipe';
